/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import InvoiceBreadcrumbs from 'domain/finance/invoice/shared/InvoiceBreadcrumbs';

const SingleInvoiceBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useInvoiceUrl();
  const id = data?.getValueBySource('id');
  const invoiceNumber = data?.getValueBySource('invoiceNumber');

  return (
    <InvoiceBreadcrumbs>
      <SingleBreadcrumbItem entity={invoiceNumber || id} link={getSingleEntityUrl(id)} />
      {children}
    </InvoiceBreadcrumbs>
  );
};

export default SingleInvoiceBreadcrumbs;
